// Default available dashboard cards
export const DASHBOARD_CARDS = {
  UPCOMING_APPOINTMENTS: {
    id: 'upcoming_appointments',
    title: 'Upcoming Appointments',
    description: 'Shows your upcoming client appointments',
    defaultEnabled: true,
    category: 'Schedule',
  },
  QUICK_ACCESS: {
    id: 'quick_access',
    title: 'Quick Access',
    description: 'Quick actions for common tasks',
    defaultEnabled: true,
    category: 'Tools',
  },
  CLIENTS_36_PLUS: {
    id: 'clients_36_plus',
    title: 'Clients 36+ Weeks',
    description: 'List of clients approaching their due date',
    defaultEnabled: true,
    category: 'Clients',
  },
  TASKS_REMINDERS: {
    id: 'tasks_reminders',
    title: 'Tasks & Reminders',
    description: 'Your upcoming tasks and reminders',
    defaultEnabled: true,
    category: 'Tasks',
  },
  RECENT_ACTIVITY: {
    id: 'recent_activity',
    title: 'Recent Activity',
    description: 'Latest updates and changes',
    defaultEnabled: true,
    category: 'Activity',
  },
  MESSAGES: {
    id: 'messages',
    title: 'Recent Messages',
    description: 'Latest messages from clients',
    defaultEnabled: false,
    category: 'Communication',
  },
  CALENDAR_OVERVIEW: {
    id: 'calendar_overview',
    title: 'Calendar Overview',
    description: 'Monthly calendar view',
    defaultEnabled: false,
    category: 'Schedule',
  },
  STATS_OVERVIEW: {
    id: 'stats_overview',
    title: 'Practice Statistics',
    description: 'Key metrics about your practice',
    defaultEnabled: false,
    category: 'Analytics',
  },
};

// Helper function to get default settings
export const getDefaultSettings = () => {
  return Object.values(DASHBOARD_CARDS).reduce((acc, card) => {
    acc[card.id] = card.defaultEnabled;
    return acc;
  }, {});
};

// Helper function to save settings to localStorage
export const saveDashboardSettings = (midwifeId, settings) => {
  localStorage.setItem(`dashboard_settings_${midwifeId}`, JSON.stringify(settings));
};

// Helper function to load settings from localStorage
export const loadDashboardSettings = (midwifeId) => {
  const saved = localStorage.getItem(`dashboard_settings_${midwifeId}`);
  if (!saved) {
    const defaultSettings = getDefaultSettings();
    saveDashboardSettings(midwifeId, defaultSettings);
    return defaultSettings;
  }
  return JSON.parse(saved);
};

// Get cards grouped by category
export const getCardsByCategory = () => {
  return Object.values(DASHBOARD_CARDS).reduce((acc, card) => {
    if (!acc[card.category]) {
      acc[card.category] = [];
    }
    acc[card.category].push(card);
    return acc;
  }, {});
}; 